var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.entry.protocol !== 'general' && _vm.entry.protocol !== 'seat')?_c('div',{staticClass:"connection-string-holder acd-actions connection-string-holder-tr"},[_c('ftp-connection',{attrs:{"droneLink":_vm.droneLink,"connectionString":_vm.connectionString,"visibility":_vm.visibility}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }